

$(document).ready(function () {

});


let otp1;
let otp2;
let otp3;
let otp4;

(function () {
	var Login = {

		init: function () {
			this.onInput();
			this.OTP();
		},

		OTP: function () {
			this.$otpinput = $('.validate-otp__input');

			this.$otpinput.on('input', function (e) {
				this.$val = $(this).val();
				this.$otpinputLen = $(this).val().length;
				this.$index = $(this).index();

				if (this.$otpinputLen < 1) {
					$(this).prev('.validate-otp__input').focus();
				}

				else {

					$(this).next('.validate-otp__input').focus().select();;

				}

				if (this.$index == 0) {
					otp1 = this.$val;
				}
				else if (this.$index == 1) {
					otp2 = this.$val;
				}
				else if (this.$index == 2) {
					otp3 = this.$val;
				}
				else if (this.$index == 3) {
					otp4 = this.$val;
				}
			});
		},

		onInput: function () {
			this.$filed = $('.input');
			this.$otpInput = $('.validate-otp__input');
			this.$filed.on('input', function () {
				this.$this = $(this);
				this.$inLen = this.$this.val().length;
			
			});

			

			this.$otpInput.on('focus', function () {
				$(this).select();
			});
		},

		Timer: function () {
			

		},


	}

	Login.init();

})();
